/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from "../../app/helpers/restClient";
import { getAccessTokenSafely } from "../../state/ducks/Member/ducks/Auth/Plugin/auth/auth";

export const fetchEmailSubscribeStatus = async (payload) => {
    const token = await getAccessTokenSafely();
    const wcEnv = { rootUri: '/' };
    const resourcePage = `retention/email-subscription/retrieve`;
    return restClient.postFacade(wcEnv, resourcePage, token, payload)
        .then((response) => response);
}